import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Col, Row, Tooltip } from "antd";
import { getRequest, postRequest } from "../../../axios";
import RupeesIcon from "../../../image/RupeesIcon.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import { ReactComponent as ArchiveRestore } from "../../../image/ArchiveRestore.svg";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";

const { Search } = Input;

const ArchivedSubscriptionList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [archivedSubscriptionList, setArchivedSubscriptionList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getSubscriptionArchiveList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("subscription-archive/", state);
        if (apiResponse.status) {
          setArchivedSubscriptionList(apiResponse.data.results);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archived_subscription_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getSubscriptionArchiveList();
    getCurrency();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "package_name" && sortOrder === "ascend") {
      sortingEnumKey = "package_name";
    }
    if (sortField === "package_name" && sortOrder === "descend") {
      sortingEnumKey = "-package_name";
    }
    if (sortField === "subscription_type" && sortOrder === "ascend") {
      sortingEnumKey = "subscription_type";
    }
    if (sortField === "subscription_type" && sortOrder === "descend") {
      sortingEnumKey = "-subscription_type";
    }

    if (sortField === "per_user_price" && sortOrder === "ascend") {
      sortingEnumKey = "per_user_price";
    }
    if (sortField === "per_user_price" && sortOrder === "descend") {
      sortingEnumKey = "-per_user_price";
    }

    if (sortField === "discount" && sortOrder === "ascend") {
      sortingEnumKey = "discount";
    }
    if (sortField === "discount" && sortOrder === "descend") {
      sortingEnumKey = "-discount";
    }

    if (sortField === "sell_price" && sortOrder === "ascend") {
      sortingEnumKey = "sell_price";
    }
    if (sortField === "sell_price" && sortOrder === "descend") {
      sortingEnumKey = "-sell_price";
    }

    if (sortField === "duration" && sortOrder === "ascend") {
      sortingEnumKey = "duration";
    }
    if (sortField === "duration" && sortOrder === "descend") {
      sortingEnumKey = "-duration";
    }

    if (sortField === "description" && sortOrder === "ascend") {
      sortingEnumKey = "description";
    }
    if (sortField === "description" && sortOrder === "descend") {
      sortingEnumKey = "-description";
    }

    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "subscriptionfeature__feature_status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-subscriptionfeature__feature_status";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("subscription-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("subscription_restore_successfully"));
        setReload(!reload);
        setSelectedRow([]);
        navigate("/subscription");
      } else {
        ErrorNotificationMsg(t("error_in_restore_subscription"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  //const handleStatus = async (user_id, status) => {
  //   confirmAlert({
  //     title: t("confirmAlert_title"),
  //     message: t("confirmAlert_message"),
  //     buttons: [
  //       {
  //         label: t("confirmAlert_ok"),
  //         onClick: () => changeStatus(user_id, status),
  //       },
  //       {
  //         label: t("confirmAlert_cancel"),
  //         onClick: () => navigate("/subscription"),
  //       },
  //     ],
  //   });
  // };

  // const changeStatus = async (id, value) => {
  //   await patchRequest(`subscription/${id}/subscription-status/`, {
  //     status: value,
  //   })
  //     .then((response) => {
  //       SuccessNotificationMsg("Status Updated Sucessfully");
  //       setReload(!reload);
  //     })
  //     .catch((error) => {});
  // };

  const getCurrency = async (data) => {
    await getRequest("business-settings/get-currency-by-business-setting/", data).then(
      (response) => {
        setCurrencySymbol(response.data.data);

      }
    );
  };

  const columns = [
    {
      title: "Package Name",
      dataIndex: "package_name",
      key: "package_name",
      sorter: true,
    },
    {
      title: "Subscription Type",
      dataIndex: "subscription_type",
      key: "subscription_type",
      sorter: true,
    },
    {
      title: `Per User Price (${currencySymbol})`,
      dataIndex: "per_user_price",
      key: "per_user_price",
      render: (value) => <span>{currencySymbol} {value}</span>,
      sorter: true,
    },
    {
      title: "Discount (%)",
      dataIndex: "discount",
      key: "discount",
      render: (discount) => <>{discount} %</>,
      sorter: true,
    },
    {
      title: `Sell Price (${currencySymbol})`,
      dataIndex: "sell_price",
      key: "sell_price",
      render: (value) => <span>{currencySymbol} {value}</span>,
      sorter: true,
    },
    {
      title: "Duration (Days)",
      dataIndex: "duration",
      key: "duration",
      render: (duration) => <>{duration} days</>,
      sorter: true,
    },

    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: true,
    },
    // {
    //   title: "STATUS",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (e, record) => (
    //     <div className="SelectStatusSec">
    //       <Select
    //         value={e ? e : record.status}
    //         onChange={(e) => handleStatus(record.id, e)}
    //         defaultValue={e}
    //       >
    //         <Select.Option value="active">
    //           <div className="dealdoneopt">{t("active")}</div>
    //         </Select.Option>
    //         <Select.Option value="in_active">
    //           <div className="contactedopt">{t("inactive")}</div>
    //         </Select.Option>
    //       </Select>
    //     </div>
    //   ),
    // },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore className="ArchiverestorImg" />
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                 Archived entries retain historical data and can be reinstated if necessary.

                </span>
              }
            >
              <h3>{t("archived_subscription")}</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/subscription">{t("subscriptionMaster")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archiveList")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>

              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Restore"
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            ></Col>
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Restore"
                />
              </Popconfirm>
            )}
          </Col> */}
          </Row>
<div className="tablewrp">
          <Table
            scroll={{
              x: 2000,
            }}
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={archivedSubscriptionList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (totalCount) => `Total ${totalCount} items`,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          </div>
           <div className="FormFooter Container">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("previous")}
              onClick={() =>
                navigate(
                  `/subscription`
                )
              }
            //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchivedSubscriptionList;
